import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.372 7.833a2.5 2.5 0 0 0 1.952-.939l1.067-1.333c.254-.318.42-.683.497-1.062h4.905l-1.48 1.48a.5.5 0 0 0 .707.707L13.707 4 11.02 1.312a.5.5 0 1 0-.707.708l1.48 1.48H6.888a2.5 2.5 0 0 0-.497-1.062L5.324 1.104A2.5 2.5 0 0 0 3.372.166H1a.5.5 0 0 0 0 1h2.372a1.5 1.5 0 0 1 1.171.563L5.61 3.062a1.5 1.5 0 0 1 0 1.874L4.543 6.27a1.5 1.5 0 0 1-1.17.563H1a.5.5 0 0 0 0 1z"
    }, null, -1)
  ])))
}
export default { render: render }